import { Asterisk } from "lucide-react";

const ITEMS = [
  "Fresh & Authentic",
  "Sliced to order",
  "30-option pickle & olive bar",
  "40-option spice & herb bar",
  "Halal menu available",
  "Family owned & run",
  "Mount Druitt, NSW",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-moss-dark bg-moss py-4 text-cream">
      <div className="animate-marquee flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="whitespace-nowrap font-mono text-xs uppercase tracking-[0.28em] sm:text-sm">{item}</span>
                <Asterisk className="mx-8 h-4 w-4 text-amber" strokeWidth={2.5} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
